<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="part001">
<h1 class="part-number"><a href="#/toc#Ref_11948a" id="Ref_11948"><span>PART ONE</span></a></h1>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?4b0621be